/* eslint-disable */
import React from "react";
import { Card, Stack, Typography } from '@mui/material';
import Label from './Label';

class ErrorBoundary extends React.Component {
    state = {
        hasError: false,
        error: { message: '', stack: '' },
        info: { componentStack: '' }
    };

    static getDerivedStateFromError = error => {
        return { hasError: true };
    };

    componentDidCatch = (error, info) => {
        this.setState({ error, info });
        console.error(error)
    };

    render() {
        const { hasError, error, info } = this.state;
        const { children } = this.props;

        return hasError ? <>
            <Card variant='elevation' sx={{ p: 3 }}>
                <Stack spacing={2}>
                    <Typography
                        variant="h4"
                        sx={{
                            my: 0,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary',
                        }}
                    >{this.props.fallback}</Typography>
                    <Typography
                        variant="subtitle"
                        sx={{
                            my: 0,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary',
                        }}
                    >
                        Please try reloading the page.
                    </Typography>

                    <Stack direction="row" justifyContent="center">
                        <Label
                            color="error"
                        >{error.toString()}</Label>
                    </Stack>
                </Stack>
            </Card>
        </> : children;
    }
}

export default ErrorBoundary;